import { DataGrid, GridColumns } from '@material-ui/data-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { ParcelaFinanceiro } from '~/pages/EmissaoNFE/protocols';
import { useEmissaoNFE } from '~/pages/EmissaoNFE/EmissaoNFEContext';
import { formatCurrencyAsText } from '~/utils/functions';
import { ButtonRow, TableContainer } from './styles';
import Swal from 'sweetalert2';
import { MdDeleteForever } from 'react-icons/md';
import { deleteItens } from '~/utils/masterDetail';
import { createDateWithoutTimezone } from '~/utils/createDateWithoutTimezone ';
import { encontrarIdAgendamentoCorrespondente } from '~/components/VincularAgendamento/utils/encontrarIdAgendamentoCorrespondente';
import { AgendamentoSelecionadosStorage } from '~/components/VincularAgendamento/class/AgendamentoSelecionadosStorage';

export const TableFinanceiro: React.FC = () => {
  const {
    parcelasFinanceiro,
    setParcelasFinanceiro,
    setParcelaSelecionada,
    setIsFormFinanceiroEditing,
    formFinanceiro: { setValue },
    isUpdate,
    masterDetail,
    setMasterDetail,
  } = useEmissaoNFE();
  const [parcelas, setParcelas] = useState<ParcelaFinanceiro[]>([]);

  const columns: GridColumns = [
    {
      field: 'num_registro',
      headerName: 'Num. Registro',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'num_condicao',
      headerName: 'Prazo',
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'cod_condicao',
      headerName: 'Cód. Condicao',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'des_condicao',
      headerName: 'Condição',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'dta_vencimento',
      headerName: 'Vencimento',
      width: 150,
      disableColumnMenu: true,
      renderCell: (row: any) => {
        const dateValue =
          typeof row.value === 'string'
            ? row.value
            : row.value.format('YYYY-MM-DD');
        return (
          <>
            {moment(createDateWithoutTimezone(dateValue)).format('DD/MM/YYYY')}
          </>
        );
      },
    },
    {
      field: 'val_parcela',
      headerName: 'Valor',
      flex: 1,
      disableColumnMenu: true,
      renderCell: (row: any) => {
        return (
          <>
            <span>{formatCurrencyAsText(row.value)}</span>
          </>
        );
      },
    },
    {
      field: 'cod_finalizadora',
      headerName: 'Cód. Finalizadora',
      hide: true,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'des_finalizadora',
      headerName: 'Finalizadora',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'acoes',
      headerName: 'Ações',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (row: any) => {
        return (
          <div>
            <ButtonRow
              type="button"
              disabled={isUpdate}
              isBlocked={isUpdate}
              onClick={() => {
                onEditItem(row.row.uuid);
              }}
              style={{ marginRight: '10px' }}
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} /> Editar
            </ButtonRow>
            <ButtonRow
              type="button"
              disabled={isUpdate}
              isBlocked={isUpdate}
              onClick={() => {
                onRemoveItem(row.row.uuid);

                const id = encontrarIdAgendamentoCorrespondente(
                  AgendamentoSelecionadosStorage.get(47),
                  row.row,
                );

                AgendamentoSelecionadosStorage.removeById(String(id), 47);
              }}
              style={{ marginRight: '10px' }}
            >
              <MdDeleteForever size={20} style={{ color: '#e63c3c' }} /> Excluir
            </ButtonRow>
          </div>
        );
      },
    },
  ];

  const onEditItem = (uuid: string) => {
    const reg = parcelasFinanceiro.find((parcela) => parcela.uuid === uuid);

    if (reg) {
      setValue('dta_vencimento', reg.dta_vencimento);
      setValue('val_financeiro', formatCurrencyAsText(reg.val_parcela));
      setValue('num_condicao', reg.num_condicao);
      setValue('finalizadora', {
        value: reg.cod_finalizadora,
        label: reg.des_finalizadora,
      });
      setValue('condicao', {
        value: reg.cod_condicao,
        label: reg.des_condicao,
      });
      setParcelaSelecionada(reg);
      setIsFormFinanceiroEditing({ isEdit: true, uuid });
    }
  };

  const onRemoveItem = async (uuid: string) => {
    const result = await Swal.fire({
      title: ``,
      text: 'Deseja realmente remover essa parcela?',

      showCancelButton: true,
      confirmButtonColor: '#07289e',
      cancelButtonColor: '#ff7b7b',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    });

    if (result.isConfirmed) {
      const parcelasDetail: any[] = await deleteItens(
        'financeiro',
        uuid,
        masterDetail,
        setMasterDetail,
      );

      setParcelasFinanceiro(parcelasDetail);
    }
  };

  return (
    <TableContainer>
      <DataGrid
        rowsPerPageOptions={[5]}
        rows={parcelasFinanceiro}
        columns={columns}
        pageSize={5}
        disableColumnSelector
        disableColumnFilter
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado...',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </TableContainer>
  );
};
